<template>
  <div class="divStyle">
    <h3 class="title">{{systemName}}</h3>
    <div style="text-align: center">
      <!--<div id="todayItem">-->
      <el-table
        :span-method="objectSpanMethod"
        height="715"
        border
        :data="itemData"
        :row-class-name="tableRowClassName"
        class="tableStyle">
        <el-table-column
          prop="truck_type_name"
          label="">
        </el-table-column>
        item
        <el-table-column
          prop="reserved_ymd"
          label="日付">
        </el-table-column>

        <el-table-column
          prop="T20"
          label="20時">
        </el-table-column>

        <el-table-column
          prop="T21"
          label="21時">
        </el-table-column>

        <el-table-column
          prop="T22"
          label="22時">
        </el-table-column>

        <el-table-column
          prop="T23"
          label="23時">
        </el-table-column>

        <el-table-column
          prop="T24"
          label="24時(0時)">
        </el-table-column>

        <el-table-column
          prop="T25"
          label="25時(1時)">
        </el-table-column>

        <el-table-column
          prop="T26"
          label="26時(2時)">
        </el-table-column>

        <el-table-column
          prop="T27"
          label="27時(3時)">
        </el-table-column>

        <el-table-column
          prop="T28"
          label="28時(4時)">
        </el-table-column>

        <el-table-column
          prop="T29"
          label="29時(5時)">
        </el-table-column>

        <el-table-column
          prop="T30"
          label="30時(6時)">
        </el-table-column>

        <el-table-column
          prop="T31"
          label="31時(7時)">
        </el-table-column>

        <el-table-column
          prop="T32"
          label="32時(8時)">
        </el-table-column>

        <el-table-column
          prop="truck_type_sum"
          label="品目計">
        </el-table-column>
      </el-table>
      <div style="margin-top: 1em;padding-left: 91%;">
        <el-button type="danger" @click.native.prevent="back()"><i class="el-icon-caret-right"style="color: white;"></i>戻　る</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import http from '../../assets/js/http'
  import _g from '../../assets/js/global'
  export default {
    data () {
      return {
        systemName: '社内向け当日搬入時間単位予約トラック台数状況',
        dataCount: 0,
        itemData: []
      }
    },
    methods: {
      back() {
        this.$router.push({ path: '/shanaikanrisha/search', query: { radio: this.$route.query.radio, fromDate: this.$route.query.fromDate, toDate: this.$route.query.toDate }})
      },
      tableRowClassName({ row, rowIndex }) {
        if (rowIndex % 11 === 10) {
          return 'warning-row'
        }
        if (rowIndex === this.dataCount - 1) {
          return 'warning-row'
        }
        return ''
      },
      objectSpanMethod({ row, column, rowIndex, columnIndex }) {
        if (columnIndex === 1) {
          if (rowIndex % 11 === 0) {
            return {
              rowspan: 11,
              colspan: 1
            }
          } else {
            return {
              rowspan: 0,
              colspan: 0
            }
          }
        }
      }
    },
    created() {
      let data = {}
      data.fromDate = this.$route.query.fromDate
      data.toDate = this.$route.query.toDate
      data.userId = this.$route.query.userId
      this.apiPost('shanaikanrisha/TruckTypeSameDayList/truckTypeSameDayList', data).then((res) => {
        this.handelResponse(res, (data) => {
          if (res.code != 200) {
            this.loading = !this.loading
            this.handleError(res)
          } else {
            this.itemData = data.list
            this.dataCount = data.dataCount
          }
        })
      })
    },
    mixins: [http]
  }
</script>

<style>
  .el-table th>.cell{
    text-align: center;
  }
  .el-table .cell{
    text-align: center;
  }
</style>
<style>
  #todayItem{
    padding: 5em;
  }
  .item_table{
    border: solid;
  }
  .el-table .warning-row {
    background: #66bb6a;
  }
  .tableStyle{
    width: 100%;
    overflow:auto;
  }
  .divStyle{
    padding: 2em;
    -webkit-border-radius: 1em;
    border-radius: 0.5em;
    -moz-border-radius: 1em;
    background-clip: padding-box;
    background-color: #F9FAFC;
    margin: 1em auto;
    height: 50.5em;
    width: 95em;
    border: 0.1em solid #8492A6;
    padding-left: 2%;
  }
  .title {
    text-align: left;
    color: #505458;
  }
</style>



// WEBPACK FOOTER //
// src/components/shanaikanrisha/todayTruckList.vue